import { Card, CardContent } from '@mui/material';
import { CrossdockingProvider } from '../application/context';
import {
  crossdockingToReceiveRouteTypes,
  toReceiveViewFactory,
} from '../application/factories';
import { useSelector } from 'react-redux';
import { SmallSpinner } from '../../../common';

export default function ToReceive(props) {
  const { activeRoute } = useSelector((state) => state.routes);

  if (activeRoute?.routeType === undefined) {
    return (
      <Card variant="outlined" elevation={0} sx={{ borderRadius: 3 }}>
        <CardContent>
          <SmallSpinner />
        </CardContent>
      </Card>
    );
  }

  const ViewComponent =
    toReceiveViewFactory[activeRoute?.routeType] ??
    toReceiveViewFactory.DEFAULT;

  if (crossdockingToReceiveRouteTypes.includes(activeRoute?.routeType)) {
    return (
      <CrossdockingProvider>
        <ViewComponent {...props} />
      </CrossdockingProvider>
    );
  }

  return <ViewComponent {...props} />;
}
